import CommonButton from "@components/CommonButton";
import {
  IconArrowBlue,
  IconArrowBlack,
  IconCollect,
  IconAiLinear,
  IconAiGradient,
  IconShare,
  IconArrowBlueFull,
  IconArrowGreyFull,
  IconRank,
  IconRankGray,
} from "@icons/index";
import { Button } from "antd";

export const ButtonExample = () => {
  return (
    <div className="flex flex-wrap gap-[40px] items-baseline">
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        大按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" type="primary" className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton size="large" type="primary" className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" type="primary" className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton size="large" type="primary" className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" type="primary" icon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton size="large" type="primary" icon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" type="primary" icon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton size="large" type="primary" icon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton size="large" className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton size="large" className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" icon={<IconCollect />} activeIcon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton size="large" icon={<IconCollect />} activeIcon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" icon={<IconCollect />} activeIcon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton size="large" icon={<IconCollect />} activeIcon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" type="filled" className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton size="large" type="filled" className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" type="filled" className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton size="large" type="filled" className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" type="filled" icon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton size="large" type="filled" icon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" type="filled" icon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton size="large" type="filled" icon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        antd 大按钮
        <div className="flex items-center gap-[8px]">
          <Button size="large" type="primary" className="w-[144px]">
            Normal
          </Button>
          <Button size="large" type="primary" className="w-[144px]" disabled>
            Disabled
          </Button>
          <Button size="large" type="primary" className="w-[144px]" disabled {...({ locked: true } as any)}>
            Locked
          </Button>
          <Button size="large" type="primary" className="w-[144px]" disabled loading>
            Normal
          </Button>
        </div>
        <div className="flex items-center gap-[8px]">
          <Button size="large" type="primary" icon={<IconCollect />}>
            Normal
          </Button>
          <Button size="large" type="primary" icon={<IconCollect />} disabled>
            Disabled
          </Button>
          <Button size="large" type="primary" icon={<IconCollect />} disabled {...({ locked: true } as any)}>
            Locked
          </Button>
          <Button size="large" type="primary" icon={<IconCollect />} disabled loading>
            Normal
          </Button>
        </div>
        <div className="flex items-center gap-[8px]">
          <Button size="large" className="w-[144px]">
            Normal
          </Button>
          <Button size="large" className="w-[144px]" disabled>
            Disabled
          </Button>
          <Button size="large" className="w-[144px]" disabled {...({ locked: true } as any)}>
            Locked
          </Button>
          <Button size="large" className="w-[144px]" disabled loading>
            Normal
          </Button>
        </div>
        <div className="flex items-center gap-[8px]">
          <Button size="large" icon={<IconCollect />}>
            Normal
          </Button>
          <Button size="large" icon={<IconCollect />} disabled>
            Disabled
          </Button>
          <Button size="large" icon={<IconCollect />} disabled {...({ locked: true } as any)}>
            Locked
          </Button>
          <Button size="large" icon={<IconCollect />} disabled loading>
            Normal
          </Button>
        </div>
        <div className="flex items-center gap-[8px]">
          <Button size="large" type="primary" ghost className="w-[144px]">
            Normal
          </Button>
          <Button size="large" type="primary" ghost className="w-[144px]" disabled>
            Disabled
          </Button>
          <Button size="large" type="primary" ghost className="w-[144px]" disabled {...({ locked: true } as any)}>
            Locked
          </Button>
          <Button size="large" type="primary" ghost className="w-[144px]" disabled loading>
            Normal
          </Button>
        </div>
        <div className="flex items-center gap-[8px]">
          <Button size="large" type="primary" ghost icon={<IconCollect />}>
            Normal
          </Button>
          <Button size="large" type="primary" ghost icon={<IconCollect />} disabled>
            Disabled
          </Button>
          <Button size="large" type="primary" ghost icon={<IconCollect />} disabled {...({ locked: true } as any)}>
            Locked
          </Button>
          <Button size="large" type="primary" ghost icon={<IconCollect />} disabled loading>
            Normal
          </Button>
        </div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        中按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton type="primary" className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton type="primary" className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton type="primary" className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton type="primary" className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="primary" icon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton type="primary" icon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton type="primary" icon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton type="primary" icon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton className="w-[144px]">Normal</CommonButton>
          <CommonButton className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton icon={<IconCollect />} activeIcon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton icon={<IconCollect />} activeIcon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton icon={<IconCollect />} activeIcon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton icon={<IconCollect />} activeIcon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="filled" className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton type="filled" className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton type="filled" className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton type="filled" className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="filled" icon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton type="filled" icon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton type="filled" icon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton type="filled" icon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        小按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="primary">
            Normal
          </CommonButton>
          <CommonButton size="small" type="primary" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="primary" locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="primary" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="primary" icon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton size="small" type="primary" icon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="primary" icon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="primary" icon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small">Normal</CommonButton>
          <CommonButton size="small" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" locked>
            Locked
          </CommonButton>
          <CommonButton size="small" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" icon={<IconCollect />} activeIcon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton size="small" icon={<IconCollect />} activeIcon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" icon={<IconCollect />} activeIcon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton size="small" icon={<IconCollect />} activeIcon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="filled">
            Normal
          </CommonButton>
          <CommonButton size="small" type="filled" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="filled" locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="filled" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="filled" icon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton size="small" type="filled" icon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="filled" icon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="filled" icon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        文字按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="text">
            Normal
          </CommonButton>
          <CommonButton size="small" type="text" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="text" locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="text" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="text" icon={<IconShare />}>
            Normal
          </CommonButton>
          <CommonButton size="small" type="text" icon={<IconShare />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="text" icon={<IconShare />} locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="text" icon={<IconShare />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="text" icon={<IconShare />} subIcon={<IconArrowBlack />} size="small">
            Normal
          </CommonButton>
          <CommonButton type="text" icon={<IconShare />} subIcon={<IconArrowBlack />} size="small" disabled>
            Disabled
          </CommonButton>
          <CommonButton type="text" icon={<IconShare />} subIcon={<IconArrowBlack />} size="small" locked>
            Locked
          </CommonButton>
          <CommonButton type="text" icon={<IconShare />} subIcon={<IconArrowBlack />} size="small" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="primary-text">Normal</CommonButton>
          <CommonButton type="primary-text" disabled>
            Disabled
          </CommonButton>
          <CommonButton type="primary-text" locked>
            Locked
          </CommonButton>
          <CommonButton type="primary-text" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="primary-text" icon={<IconShare />}>
            Normal
          </CommonButton>
          <CommonButton type="primary-text" icon={<IconShare />} disabled>
            Disabled
          </CommonButton>
          <CommonButton type="primary-text" icon={<IconShare />} locked>
            Locked
          </CommonButton>
          <CommonButton type="primary-text" icon={<IconShare />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="primary-text" icon={<IconShare />} subIcon={<IconArrowBlue />}>
            Normal
          </CommonButton>
          <CommonButton type="primary-text" icon={<IconShare />} subIcon={<IconArrowBlue />} disabled>
            Disabled
          </CommonButton>
          <CommonButton type="primary-text" icon={<IconShare />} subIcon={<IconArrowBlue />} locked>
            Locked
          </CommonButton>
          <CommonButton type="primary-text" icon={<IconShare />} subIcon={<IconArrowBlue />} loading>
            Normal
          </CommonButton>
        </div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        图标按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton size="middle" icon={<IconCollect />}></CommonButton>
          <CommonButton size="middle" icon={<IconCollect />} disabled></CommonButton>
          <CommonButton size="middle" icon={<IconCollect />} locked></CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="middle" type="text" icon={<IconCollect />}></CommonButton>
          <CommonButton size="middle" type="text" icon={<IconCollect />} disabled></CommonButton>
          <CommonButton size="middle" type="text" icon={<IconCollect />} locked></CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="middle" type="primary-filled" icon={<IconRank />}></CommonButton>
          <CommonButton
            size="middle"
            type="primary-filled"
            icon={<IconRank />}
            disabledIcon={<IconRankGray />}
            disabled
          ></CommonButton>
          <CommonButton
            size="middle"
            type="primary-filled"
            icon={<IconRank />}
            disabledIcon={<IconRankGray />}
            locked
          ></CommonButton>
        </div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        标签按钮
        <CommonButton size="mini" type="tag" icon={<IconCollect />} className="flex items-center gap-[4px]">
          Normal
          <IconArrowBlueFull />
        </CommonButton>
        <CommonButton size="mini" type="tag" icon={<IconCollect />} className="flex items-center gap-[4px]" disabled>
          Disabled
          <IconArrowGreyFull />
        </CommonButton>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        渐变按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton size="middle" type="primary-gradient" className="w-[124px]">
            middle
          </CommonButton>
          <CommonButton size="middle" type="primary-gradient" className="w-[124px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="middle" type="primary-gradient" className="w-[124px]" locked>
            Locked
          </CommonButton>
          <CommonButton size="middle" type="primary-gradient" className="w-[124px]" loading>
            middle
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="middle" type="primary-gradient" icon={<IconAiLinear />}>
            middle
          </CommonButton>
          <CommonButton size="middle" type="primary-gradient" icon={<IconAiLinear />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="middle" type="primary-gradient" icon={<IconAiLinear />} locked>
            Locked
          </CommonButton>
          <CommonButton size="middle" type="primary-gradient" icon={<IconAiLinear />} loading>
            middle
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="middle" type="filled-gradient" className="w-[124px]">
            middle
          </CommonButton>
          <CommonButton size="middle" type="filled-gradient" className="w-[124px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="middle" type="filled-gradient" className="w-[124px]" locked>
            Locked
          </CommonButton>
          <CommonButton size="middle" type="filled-gradient" className="w-[124px]" loading>
            middle
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="middle" type="filled-gradient" icon={<IconAiGradient />}>
            middle
          </CommonButton>
          <CommonButton size="middle" type="filled-gradient" icon={<IconAiGradient />} disabled>
            Disabled
          </CommonButton>
          <CommonButton size="middle" type="filled-gradient" icon={<IconAiGradient />} locked>
            Locked
          </CommonButton>
          <CommonButton size="middle" type="filled-gradient" icon={<IconAiGradient />} loading>
            middle
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]"></div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        Ghost 按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton type="primary" ghost className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton type="primary" ghost className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton type="primary" ghost className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton type="primary" ghost className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="primary" ghost icon={<IconCollect />}>
            Normal
          </CommonButton>
          <CommonButton type="primary" ghost icon={<IconCollect />} disabled>
            Disabled
          </CommonButton>
          <CommonButton type="primary" ghost icon={<IconCollect />} locked>
            Locked
          </CommonButton>
          <CommonButton type="primary" ghost icon={<IconCollect />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton ghost className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton ghost className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton ghost className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton ghost className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="primary" ghost>
            Normal
          </CommonButton>
          <CommonButton size="small" type="primary" ghost disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="primary" ghost locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="primary" ghost loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" type="primary" ghost className="w-[144px]">
            Normal
          </CommonButton>
          <CommonButton size="large" type="primary" ghost className="w-[144px]" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" type="primary" ghost className="w-[144px]" locked>
            Locked
          </CommonButton>
          <CommonButton size="large" type="primary" ghost className="w-[144px]" loading>
            Normal
          </CommonButton>
        </div>
      </div>
      <div className="inline-flex flex-col gap-[4px] p-[20px] border border-dashed border-[#9747FF] rounded-[8px]">
        Link 按钮
        <div className="flex items-center gap-[8px]">
          <CommonButton type="link">Normal</CommonButton>
          <CommonButton type="link" disabled>
            Disabled
          </CommonButton>
          <CommonButton type="link" locked>
            Locked
          </CommonButton>
          <CommonButton type="link" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton type="link" icon={<IconShare />}>
            Normal
          </CommonButton>
          <CommonButton type="link" icon={<IconShare />} disabled>
            Disabled
          </CommonButton>
          <CommonButton type="link" icon={<IconShare />} locked>
            Locked
          </CommonButton>
          <CommonButton type="link" icon={<IconShare />} loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="small" type="link">
            Normal
          </CommonButton>
          <CommonButton size="small" type="link" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="small" type="link" locked>
            Locked
          </CommonButton>
          <CommonButton size="small" type="link" loading>
            Normal
          </CommonButton>
        </div>
        <div className="flex items-center gap-[8px]">
          <CommonButton size="large" type="link">
            Normal
          </CommonButton>
          <CommonButton size="large" type="link" disabled>
            Disabled
          </CommonButton>
          <CommonButton size="large" type="link" locked>
            Locked
          </CommonButton>
          <CommonButton size="large" type="link" loading>
            Normal
          </CommonButton>
        </div>
      </div>
    </div>
  );
};
